import { ChevronDown } from "lucide-react";

export default function Faq({ t }) {
  return (
    <section id="faq" className="py-20 sm:py-28 bg-white border-y border-[var(--border)]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 sm:px-10">
        <div className="text-center mb-10">
          <span className="label-eyebrow">{t.faq.label}</span>
          <h2 className="font-heading text-4xl sm:text-5xl mt-3">{t.faq.title}</h2>
        </div>
        <div className="space-y-3">
          {t.faq.items.map((item, i) => (
            <details
              key={item.q}
              className="group card-surface !rounded-2xl px-6 py-4"
              data-testid={`faq-item-${i}`}
            >
              <summary className="flex items-center justify-between gap-4 cursor-pointer list-none font-heading text-lg text-[var(--heading)] min-h-[44px]">
                {item.q}
                <ChevronDown className="w-5 h-5 shrink-0 text-[var(--primary)] transition-transform group-open:rotate-180" />
              </summary>
              <p className="text-[var(--body)] leading-relaxed pt-3">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
